import breazeIconOrange from "@/assets/Breaze_Icon_orange.png";
import breazeStackedTagline from "@/assets/Breaze_Stacked_Tagline.png";
import { cn } from "@/lib/utils";

export function BreazeMarkOrange({ className }: { className?: string }) {
  return (
    <svg
      className={cn("shrink-0", className)}
      viewBox="0 0 38 38"
      width={38}
      height={38}
      aria-hidden
    >
      <rect width="38" height="38" rx="6" fill="#FD683E" />
      <text
        x="19"
        y="26"
        textAnchor="middle"
        fill="white"
        fontSize="18"
        fontWeight="700"
        fontFamily="'Public Sans', system-ui, -apple-system, sans-serif"
      >
        B
      </text>
    </svg>
  );
}

export function BreazeIconCollapsed({ className }: { className?: string }) {
  return (
    <img src={breazeIconOrange} alt="Breaze" className={cn("shrink-0 object-contain", className)} />
  );
}

export function BreazeWordmarkNav({ className }: { className?: string }) {
  return (
    <img
      src={breazeStackedTagline}
      alt="Breaze"
      className={cn("h-9 w-auto shrink-0 object-contain", className)}
    />
  );
}

export function BreazeWordmarkWhite({ className }: { className?: string }) {
  return (
    <span className={cn("text-2xl font-bold tracking-tight text-white drop-shadow-sm", className)}>
      Breaze
    </span>
  );
}

export function BreazeLogoSidebar({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center", className)}>
      <img
        src={breazeStackedTagline}
        alt="Breaze"
        className="h-20 w-auto shrink-0 object-contain"
      />
    </div>
  );
}
